import React, { useEffect, useState } from 'react'
import Utils from './utils.js'
import Fetch from './fetch.js'
import { __experimentalInputControl as InputControl } from '@wordpress/components'
import { Button } from '@wordpress/components'

function License() {

    const [license, setLicense] = useState()
    const [api_key, setApiKey] = useState()
    useEffect(() => {
        async function loadLicense() {
           
            const response = await fetch(DBD.api_license_key.url, {
                credentials: 'include',
                headers: {
                  'content-type': 'application/json',
                  'X-WP-Nonce': DBD.api_license_key.nonce
                }
            })

            if(!response.ok) {
                return;
            }
            
            const licenseVal = await response.json();
                     
            setLicense(licenseVal.license)
            setApiKey(licenseVal.api_key)
        }
    
        loadLicense();
        
    }, [])

    const saveLicense = ( event ) => {
                
        let values = {"license":license,"api_key":api_key}
        const inputs = JSON.stringify(values)

        let params = {
			url : DBD.api_license_key.url,
			nonce : DBD.api_license_key.nonce,
			action : 'save_license',
			data : inputs,
		};
			
        let noticeContainer = document.querySelector('.davenport-theme-options-notice');
		Fetch.send(params,function(message){
            Utils.setNotice(noticeContainer,message);
            localStorage.setItem('active-tab','license');
            location.reload();
        });
    }

    return(
    
        <>
            <InputControl
                    label="License Key"
                    name="license_key"
                    type="text"
                    value={ license }
                    onChange={ ( newValue ) => { setLicense( newValue ) }}
                />

            <InputControl
                    label="API Key"
                    name="api_key"
                    type="text"
                    value={ api_key }
                    onChange={ ( newValue ) => { setApiKey( newValue ) }}
                />
         
            <Button 
                className="btn btn-primary sm save-license" 
                onClick={(e) => {saveLicense(e)}}
            >
                Save
            </Button>
        </>
    );

}

export default License